export const qaRu = [
  {
    title:
      "Как получить функционал оформления пропусков и других заявок онлайн?",
    content: `
      <ol>
        <li>Заключите договор с АО «ЭКСПОЦЕНТР» на участие в выставке.</li>
        <li>После заключения договора, выставления счета, и активации выставки по электронной почте Вы получите письмо, которое позволит активировать все возможности личного кабинета (оформление пропусков, оформление заявки на размещение в каталоге и другой функционал в режиме онлайн).</li>
        <li>Перейдите по ссылке из письма и получите доступ к функционалу личного кабинета.</li>
      </ol>
    `
  },
  {
    title: "Как оформить заказ на дополнительные услуги в Личном кабинете?",
    content: `
      <ol>
        <li>В верхнем меню выберите «Заказ услуг» либо в разделе «Услуги на выставке» выберите карточку «Заказ услуг» - Перейти в каталог.</li>
        <li>Выберете необходимые услуги из каталога и добавьте их в корзину.</li>
        <li>Оформите заказ дополнительных услуг.</li>
        <li>Получите статус об обработке заказа.</li>
        <li>При необходимости, согласуйте услуги заказа с ответственным менеджером.</li>
        <li>При необходимости, подтвердите изменения в заказе в Личном кабинете.</li>
        <li>При необходимости, оформите договор на дополнительные услуги (например, услуги связи).</li>
        <li>Получите и оплатите счет на дополнительные услуги.</li>
        <li>Заказанные услуги оказываются только после поступления оплаты согласно выставленному счету.</li>
      </ol>
    `
  },
  {
    title:
      "Когда прекращается оформление заказа на дополнительные услуги в Личном кабинете?",
    content: `
        <div>До начала монтажа выставки.</div>
        <div>Заявки, поданные после определенной даты, будут удовлетворены при наличии технической возможности с учетом повышающего коэффициента.</div>
        <p>
          Сервис Бюро  <br />
          Тел.: <a href="tel:+7 (499) 795-37-79">+7 (499) 795-37-79</a><br />
          E-mail: <a href="mailto:usluga@expocentr.ru">usluga@expocentr.ru</a>
        </p>
    `
  },

  {
    title: "Как оформить «Удостоверение участника выставки» в Личном кабинете?",
    content: `
      <ol>
        <li>В верхнем меню выберите «Пропуска» либо в разделе «Услуги на выставке» выберите
        карточку «Пропуска» - Удостоверения участника.</li>
        <li>Заполните онлайн данные сотрудников, которым планируете выдать удостоверения
        (пакетно или по одному).</li>
        <li>Возьмите с собой распечатанные пропуска. С первого дня монтажа с 08:00 Вы можете пройти на территорию выставки через входные турникеты. После турникетов на стойке возьмите пластиковый карман и ленту, вложите свое удостоверение и используйте в течение монтажа, проведения выставки и демонтажа.</li>
      </ol>

      <details class="note">
        <summary class="note__summary">
          <span class="note__summary-text">Примечание</span>
        </summary>

        <p>
          «Удостоверение участника выставки»  предоставляет право нахождения на территории AO «Экспоцентр»
          для проведения монтажных/демонтажных работ и весь период работы выставки (т.е. они действуют с
          первого дня монтажа до последнего дня демонтажа с 08:00 до 20:00).
        </p>

        <p>Согласно общим условиям участия «Удостоверения участника выставки» предоставляются из расчета:</p>

        <ul>
          <li>
            1 пропуск на каждые 3 кв. м – при аренде площади до 90 кв. м; <br>
            (30 пропусков – при аренде площади 90 кв. м)
          </li>

          <li>дополнительно 1 пропуск на каждые 6 кв. м – при аренде площади свыше 90 кв. м.</li>
        </ul>

        <p>
            Дополнительные «Удостоверения участника выставки» (сверх установленного норматива) можно заказать через Личный кабинет участника выставки или в Сервис Бюро.
            Тел.: <a href="tel:+74997953779">+7 (499) 795-37-79</a> (многоканальный)
        </p>

        <p><a href="mailto:pass@expocentr.ru">pass@expocentr.ru</a></p>

        <p>
          Сервис Бюро находится по адресу: г. Москва, Сокольнический вал, 1А или в офисе АО «ЭКСПОЦЕНТР» на выставке.
        </p>
      </details>
    `
  },
  {
    title: "Как оформить приглашение на въезд в РФ в Личном кабинете?",
    content: `<ol>
<li>В верхнем меню выберите «Пропуска» либо в разделе «Услуги на выставке» выберите карточку «Пропуска» - «Удостоверения участника».</li>
<li>При заполнении данных сотрудника поставьте признак «Оформить приглашение на въезд в РФ».</li>
<li>Заполните онлайн данные сотрудника, которому требуется приглашений на въезд в РФ и сохраните заявку.</li>
<li>Данные сотрудника, которому требуется приглашений на въезд в РФ, будут направлены специалисту Отдела протокола.</li>
<li>Специалист Отдела протокола свяжется с Вами для сбора необходимых документов для оформления приглашения на въезд в РФ.</li>
<li>«Удостоверения участника» с оформленным приглашением на въезд в РФ нельзя распечатать из Личного кабинета.</li>
<li>После получения приглашения на въезд в РФ и приезда на выставку, обратитесь в Сервис Бюро АО «ЭКСПОЦЕНТР» для получения «Удостоверения участника» лично под подпись, при предъявлении документа, удостоверяющего личность.</li>
<li>«Удостоверения участника» с признаком «Оформить приглашение на въезд в РФ» нельзя удалить из Личного кабинета.</li>
<li>При ошибочном оформлении, для удаления «Удостоверения участника» с признаком «Оформить приглашение на въезд в РФ» обратитесь к специалисту Отдела протокола.
<p> Тел.: <a href="tel:+74992563023">+7 (499) 256-30-23</a> <br>
 <a href="mailto:visa@expocentr.ru">visa@expocentr.ru</a>
</p></li>

</ol>`
  },
  {
    title: "Как оформить разовый автомобильный пропуск в Личном кабинете?",
    content: `
      <ol>
        <li>В верхнем меню выберите «Пропуска» либо в разделе «Услуги на выставке» выберите карточку «Пропуска» - Разовый автомобильный пропуск.</li>
        <li>Заполните данные для пропуска в Личном кабинете, если такой функционал доступен.</li>
        <li>Распечатайте пропуска, скачайте накладную на ввоз/вывоз оборудования, изучите правила проезда и парковки.</li>
      </ol>
    `
  },

  {
    title: "Как оформить пропуска на монтаж/демонтаж в Личном кабинете?",
    content: `
      <p>
        «Пропуск на период монтажа/демонтажа выставки»  оформляется для техников, наладчиков,
        строителей, рабочих и других сотрудников экспонента, которые будут заняты при работах только
        на монтаже и демонтаже экспозиции.
      </p>

      <p>
        Фирмы – застройщики выставочных стендов получают пропуска для своих специалистов
        самостоятельно (в том числе через личный кабинет участника) после того, как пройдут
        аккредитацию в ООО «Экспоконста».
      </p>

      <p>
        Если Ваша компания-участник выставки и одновременно является самозастройщиком, то Вы также получите функционал оформления пропусков на монтаж-демонтаж онлайн через Личный кабинет, после аккредитации в ООО «Экспоконста».
      </p>

      <ol>
        <li>Пройдите аккредитацию в ООО «Экспоконста».</li>
        <li>После заключения договора, по электронной почте Вы получите письмо, которое позволит активировать все возможности личного кабинета (оформление пропусков, оформление заявки на размещение в каталоге и другой функционал в режиме онлайн).</li>
        <li>Перейдите по ссылке из письма и получите доступ к функционалу личного кабинета.</li>
        <li>В верхнем меню выберите «Пропуска» либо в разделе «Услуги на выставке» выберите карточку «Пропуска» - Пропуск на монтаж/демонтаж.</li>
        <li>Заполните онлайн данные сотрудников, которым планируете выдать пропуска (пакетно или по одному), если такой функционал доступен.</li>
        <li>Возьмите с собой распечатанные пропуска. С первого дня монтажа с 08:00 Вы можете пройти на территорию выставки через входные турникеты.</li>
      </ol>
    `
  },

  {
    title: "Как увеличить количество пропусков?",
    content: `
      <p>
        Дополнительные «Удостоверения участника выставки» (сверх установленного норматива) можно заказать через Личный кабинет участника выставки или в Сервис Бюро.
      </p>

      <p>
        Дополнительная информация: <br />

        Тел.: <a href="tel:+7 (499) 795-37-79">+7 (499) 795-37-79</a> (многоканальный)<br />
        <a href="mailto:pass@expocentr.ru">pass@expocentr.ru</a>
      </p>

      <p>
        Сервис Бюро находится по адресу: г. Москва, Сокольнический вал, 1А или в офисе АО «ЭКСПОЦЕНТР» на выставке.
      </p>

      <details class="note">
        <summary class="note__summary">
          <div class="note__summary-text">Примечание</div>
        </summary>

        <p>Согласно общим условиям участия «Удостоверения участника выставки» предоставляются из расчета:</p>

        <ul>
          <li>
            1 пропуск на каждые 3 кв. м – при аренде площади до 90 кв. м;<br />
            (30 пропусков – при аренде площади 90 кв. м)
          </li>
          <li>дополнительно 1 пропуск на каждые 6 кв. м – при аренде площади свыше 90 кв. м.</li>
        </ul>
      </details>
    `
  },

  {
    title: "Когда прекращается оформление пропусков?",
    content: `
      <p>В последний день проведения выставки.</p>
      <p>Функция скачивания и печати пропусков открывается за месяц до начала монтажа выставки.</p>
      <p>
        Но, если у Вас не исчерпана доступная квота, Вы можете оформить пропуска и по прошествии
        этого времени во время монтажа, проведения выставки, демонтажа.
      </p>
    `
  },
  {
    title: "Как оформить заявку на размещение информации в каталог?",
    content: `
      <ol>
        <li>В верхнем меню выберите «Размещение в каталоге» либо в разделе «Услуги на выставке»
        выберите карточку «Размещение в каталоге»</li>
        <li>Заполните форму заявки онлайн.</li>
        <li>Получите статус об обработке заявки.</li>
      </ol>
    `
  },

  {
    title: "Что делать, если я не успел оформить все в срок онлайн?",
    content: `
     <p>
        Если Вы не оформили заказ на дополнительные услуги в срок, Вам необходимо будет воспользоваться старой схемой, дополнительные услуги для экспонентов можно заказать за безналичный расчет или наличный расчет в Сервис Бюро.
      </p>
       <p>
        Дополнительная информация: <br />

        Тел.: <a href="tel:+7 (499) 795-37-79">+7 (499) 795-37-79</a> (многоканальный)<br />
        <a href="mailto:usluga@expocentr.ru">usluga@expocentr.ru</a>
      </p>

      <p>
        Сервис Бюро находится по адресу: г. Москва, Сокольнический вал, 1А или в офисе АО «ЭКСПОЦЕНТР» на выставке.
      </p>
      <p>
        Если информация в каталог не предоставлена, во всех официальных изданиях выставки (каталоге, путеводителе и интерактивном каталоге-путеводителе) будет опубликовано только название компании, страна и номер стенда.
      </p>

      <p>
        Если Вы не оформили пропуска в срок, Вам необходимо будет воспользоваться старой схемой,
        заполнив все документы вручную, используя формы из руководства участника.
      </p>
    `
  },

  {
    title: "Когда можно скачать акты оказанных услуг из Личного кабинета?",
    content: `
      <p>
        По готовности актов оказанных услуг, обычно, не позднее, чем за 3 дня до начала монтажа выставки.
      </p>
    `
  },

  {
    title: "Как добавить пользователя Личного кабинета?",
    content: `
      <ol>
        <li>В верхнем меню выберите «Пользователи», либо выберите карточку «Пользователи» - Добавить пользователя.</li>
        <li>Введите e-mail нового пользователя и определите права доступа (только просмотр, редактирование, администратор, застройщик).</li>
        <li>На указанный e-mail придет письмо, которое позволит активировать все возможности личного кабинета (оформление пропусков, оформление заявки на размещение в каталоге и другой функционал в режиме онлайн).</li>
      </ol>
    `
  },

  {
    title:
      "Как коллективному организатору добавить субэкспонента в Личном кабинете?",
    content: `
      <ol>
        <li>В верхнем меню выберите «Субэкспоненты», либо выберите карточку «Субэкспоненты» - Управление субэкспонентами.</li>
        <li>Нажмите «Добавить субэкспонента», заполните необходимые поля и определите квоты на удостоверения участников.</li>
        <li>На указанный e-mail придет письмо, которое позволит активировать все возможности личного кабинета (оформление пропусков, оформление заявки на размещение в каталоге и другой функционал в режиме онлайн).</li>
        <li>В списке субэкспонентов определите права доступа (только просмотр или редактирование информации).</li>
        <li>Ваш субэкспонент может самостоятельно оформить заявку на публикацию в каталоге и пропуска.
Вы можете заполнить данные за Вашего субэкспонента. Выберите субэкспонента и перейдите в его профиль. </li>
      </ol>
    `
  },

  {
    title: "Обмен в ЭДО",
    content: `
      Если Вы хотите получать закрывающие документы в ЭДО:
      <ol>
          <li>В верхнем меню выберите «Документы» либо в разделе «Документы и пропуска» выберите карточку «Документы» - Обмен в ЭДО.</li>
          <li>Выберете необходимые пункты для обмена документами в ЭДО.</li>
          <li>Направьте нам приглашение в Контур.Диадок (АО «ЭКСПОЦЕНТР», ИНН 7718033809).</li>
      </ol>
    `
  }
];

export const qaEng = [
  {
    title:
      "How do I get functions of filling in the passes and applications online?",
    content: `
      <ol>
        <li>Sign the Contract with EXPOCENTRE AO for participation in the exhibition.</li>
        <li>After signing the contract, invoicing, and activating the exhibition, you will receive an e-mail allowing you to activate all the features of your personal account (pass issuance, catalogue application and other online options).</li>
        <li>Receive an e-mail with access to the functions of your personal account.</li>
      </ol>
    `
  },
  {
    title:
      "How do I place an order for additional services in my personal account?",
    content: `
      <ol>
        <li>Select “Ordering services” from the top menu or select the “Ordering services” card from the “Exhibition services” section – Go to the catalogue.</li>
        <li>Select the required services from the catalogue and add them to your cart.</li>
        <li>Place an order for additional services. </li>
        <li>Get a status of order processing.</li>
        <li>If necessary, coordinate the services of the order with the responsible manager.</li>
        <li>If necessary, confirm changes to the order in your personal account.</li>
        <li>If necessary, contract for additional services (e.g. communication services).</li>
        <li>Receive and pay the invoice for additional services.</li>
        <li>Ordered services are only rendered after receipt of payment according to the invoice.</li>
      </ol>
    `
  },
  {
    title:
      "When do I stop ordering additional services in my personal account?",
    content: `
        <div>Before the assembly of the exhibition begins.</div>
        <div>Applications submitted after a certain date are accepted only if equipment is available and shall be calculated using the multiplying coefficient.</div>
        <p>
            Service Bureau  <br />
            Tel.: <a href="tel:+7 (499) 795-37-79">+7 (499) 795-37-79</a><br />
            E-mail: <a href="mailto:usluga@expocentr.ru">usluga@expocentr.ru</a>
        </p>
    `
  },

  {
    title: "How do I get Exhibitor passes online?",
    content: `
      <ol>
        <li>Choose “Passes” in the upper menu section or in the section called “Services at the exhibition”
the card “Exhibitor Passes”.</li>
        <li>Fill in the data of the staff members, whom you are going to give Exhibitor passes (group adding
or one by one).</li>
        <li>Download, print your passes and take it with you. You are able to go to the territory of exhibition using entrances turnstiles since from 8 a.m. till 8 p.m. on the first day of mounting. Passing turnstiles on the counter take the pass cover and the lanyard to save your Exhibitor pass as it is valid during mounting, running and dismantling of the exhibition.</li>
      </ol>

      <details class="note">
        <summary class="note__summary">
          <div class="note__summary-text">Note</div>
        </summary>

        <p>
          Exhibitor passes are valid for multi-entrance to Expocentre Fairgrounds throughout the mounting, running and
  dismantling periods of the exhibition (from 8 a.m. till 8 p.m.)
        </p>

        <p>According to the General terms of participation Exhibitor passes are provided at the rate of:</p>

        <ul>
          <li>
            one pass for every 3 sq m of the rented space if the booth area is up to 90 sq m (inclusive);
          </li>

          <li>30 passes and one additional pass for every 6 sq m of the rented space if the exhibitor booth is more than
  90 sq m.</li>
        </ul>

        <p>
            You can order additional exhibitor IDs via your personal exhibitor account or at Service Bureau.
            Phone <a href="tel:+7 (499) 795-37-79">+7 (499) 795-37-79</a>
        </p>

        <p><a href="mailto:pass@expocentr.ru">pass@expocentr.ru</a></p>

        <p>
          The Service Bureau is located at 1A Sokolnicheskiy val, Moscow, or at the office of EXPOCENTRE at the exhibition.
        </p>
      </details>
    `
  },
  {
    title:
      "How do I get an invitation for entry to the Russian Federation in my Personal Account?",
    content: `<ol>
<li>Choose ‘Passes’ in the upper menu or in the section called Services at the Exhibition, then choose ‘Exhibitor Passes’.</li>
<li>When filling in the employee's data, tick the box ‘Issue an invitation to enter the Russian Federation’.</li>
<li>Fill in online data of the employee who requires an invitation to enter the Russian Federation and save the application.</li>
<li>The data of the employee who requires an invitation to enter the Russian Federation will be forwarded to a member of the Protocol Department.</li>
<li>A member of the Protocol Department will contact you to collect the required documents to issue an invitation to enter the Russian Federation.</li>
<li>Exhibitor Passes with an issued invitation to enter the Russian Federation cannot be printed out from a Personal Account.</li>
<li>After receiving an invitation to enter the Russian Federation and arriving at the exhibition, please proceed to Service Bureau of EXPOCENTRE AO to receive an Exhibitor Pass in person and against signature upon presentation of an identity document.</li>
<li>Exhibitor Passes with the indication ‘Issue an invitation to enter the Russian Federation’ cannot be deleted from a Personal Account.</li>
<li>In case of an incorrect registration, please contact a member of the Protocol Department to remove the Exhibitor Pass with the indication ‘Issue an invitation to enter the Russian Federation’.
<p> Phone <a href="tel:+74992563023">+7 (499) 256-30-23</a> <br>
 <a href="mailto:visa@expocentr.ru">visa@expocentr.ru</a>
</p></li>
</ol>`
  },
  {
    title: "How do I get one-entry Car Pass online?",
    content: `
      <ol>
        <li>Choose “Passes” in the upper menu section or in the section called “Services at the exhibition”
the card “One-entry Car Passes”.</li>
        <li>Fill in the data requested in your personal account, if such functionality is available.</li>
        <li>Download, print your passes and take it with you, download the delivery/removal permit
application/consignment note, take into account the Procedure for delivery/removal of
equipment and exhibits, rules for the vehicles use at Expocentre Fairgrounds.</li>
      </ol>
    `
  },

  {
    title:
      "How do I get Work and Service Passes (for mounting and dismantling periods) online?",
    content: `
      <p>Mounting/Dismantling passes or Work and Service Passes are issued to technicians, engineers, booth
builders and other staff members engaged only in mounting and dismantling of the exhibition (during
the exhibition running isn’t valid).</p>

      <p>Contractors (booth construction companies) get the passes for its specialists independently (including
the service of Exhibitor portal) after being accredited by EXPOCONSTA OOO.</p>

      <p>If your company is both a participant and a booth builder, you will get the functions to fill in the Work and Service Passes online using the Exhibitor portal after being accredited by EXPOCONSTA OOO.</p>

      <ol>
        <li>Get an accreditation in EXPOCONSTA OOO.</li>
        <li>After signing the contract, you will receive an e-mail that will enable you to activate all the features of your personal account (pass issuance, catalogue application and other online options).</li>
        <li>Receive an e-mail with access to the functions of your personal account.</li>
        <li>Choose “Passes” in the upper menu section or in the section called “Services at the exhibition”
the card “mounting/dismantling passes”.</li>
        <li>Fill in the data of the staff members, whom you are going to give Exhibitor passes (group adding or one by one), if such functionality is available.</li>
        <li>Download, print your passes and take it with you. You are able to go to the territory of exhibition using entrances turnstiles since from 8 a.m. till 8 p.m. on the first day of mounting.</li>
      </ol>
    `
  },

  {
    title: "How do I increase the pass quota?",
    content: `
      <p>You can order additional exhibitor IDs via your personal exhibitor account or at Service Bureau.</p>

      <p>
        Phone <a href="tel:+7 (499) 795-37-79">+7 (499) 795-37-79</a><br />
        <a href="mailto:pass@expocentr.ru">pass@expocentr.ru</a>
      </p>

      <p>
      The Service Bureau is located at 1A Sokolnicheskiy val, Moscow, or at the office of EXPOCENTRE at the exhibition.
      </p>

      <details class="note">
        <summary class="note__summary">
          <div class="note__summary-text">Note</div>
        </summary>

        <p>According to the General terms of participation Exhibitor passes are provided at the rate of:</p>

        <ul>
          <li>one pass for every 3 sq m of the rented space if the booth area is up to 90 sq m (inclusive);</li>
          <li>30 passes and one additional pass for every 6 sq m of the rented space if the exhibitor booth is more than
  90 sq m.</li>
        </ul>
      </details>
    `
  },

  {
    title: "When is the deadline for getting passes?",
    content: `
      <p>On the last day of the exhibition.</p>

      <p>Download and printing of the passes are available one month before the mounting of the exhibition.</p>

      <p>If your pass quota still available, you may get the passes online during mounting, running and
dismantling periods of the exhibition.</p>
    `
  },

  {
    title:
      "How do I apply for publishing the information in the Exhibition Official Catalogue\n" +
      "online?",
    content: `
      <ol>
        <li>Choose “Publication in the Catalogue ” in the upper menu section or in the section called
“Services at the exhibition” the card “Publication in the Catalogue”.</li>
        <li>Fill in the form online.</li>
        <li>Get the status of the application processing.</li>
      </ol>
    `
  },

  {
    title: "What if I did not manage to arrange everything on time online?",
    content: `
        <p>
            If you have not placed an order for additional services in time, you will have to use the old scheme, additional services for exhibitors can be ordered for non-cash or cash at the Service Bureau.
        </p>
        <p>
            Phone: <a href="tel:+7 (499) 795-37-79">+7 (499) 795-37-79</a>
        </p>

        <p><a href="mailto:usluga@expocentr.ru">usluga@expocentr.ru</a></p>

        <p>
            The Service Bureau is located at 1A Sokolnicheskiy val, Moscow, or at the office of EXPOCENTRE at the exhibition.
        </p>
        <p>If information is not submitted to the catalogue, only the company name, country and stand number will be published in all official publications of the exhibition (catalogue, guide and online catalogue-guide).</p>

        <p>If you didn’t fill in the forms to get passed online on time, you will have an opportunity to use the
scheme, described in the Exhibitor Manual (on website of the exhibition).</p>
    `
  },

  {
    title:
      "When can I download the acceptance certificates from my personal account?",
    content: `
      <p>
        When the acceptance certificates are ready, usually no later than 3 days before the assembly of the exhibition begins.
      </p>
    `
  },

  {
    title: "How can I add a user to my personal account?",
    content: `
      <ol>
        <li>Choose “Users” in the upper menu section or in the section called “Users” the card “Add user”.</li>
        <li>Enter the e-mail address of the new user and define the access rights (read only, editing, administrator, 
installer).</li>
        <li>An e-mail will be sent to the indicated e-mail address allowing you to activate all the features of your personal account (pass issuance, catalogue application and other online options).</li>
      </ol>
    `
  },

  {
    title:
      "How can a collective exhibitor add a sub-exhibitor in the personal account?",
    content: `
      <ol>
        <li>Choose “Sub-exhibitors” in the upper menu section or in the section called “Sub-exhibitors” the card “Manage sub-exhibitors”.</li>
        <li>Click on “Add sub-exhibitor”, fill in the required fields and define the quotas for exhibitor passes.</li>
        <li>An e-mail will be sent to the indicated e-mail address allowing you to activate all the features of your personal account (pass issuance, catalogue application and other online options).</li>
        <li>In the list of sub-exhibitors, define access rights (viewing only or editing).</li>
        <li>Your sub-exhibitor can apply for publishing the information in the Exhibition Official Catalogue and passes on their own.
You can fill in the information for your sub-exhibitor. Choose a sub-exhibitor and go to their profile.</li>
      </ol>
    `
  }
];
